import { render, staticRenderFns } from "./404Error.vue?vue&type=template&id=5832eac8"
import script from "./404Error.vue?vue&type=script&lang=ts"
export * from "./404Error.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports